export const ADD_PARTICIPANT_BEGIN = 'ADD_PARTICIPANT_BEGIN'
export const ADD_PARTICIPANT_SUCCESS = 'ADD_PARTICIPANT_SUCCESS'
export const ADD_PARTICIPANT_FAILED = 'ADD_PARTICIPANT_FAILED'


const addParticipantBegin =   (payload) => ({ type: ADD_PARTICIPANT_BEGIN, payload })
const addParticipantSuccess = (payload) => ({ type: ADD_PARTICIPANT_SUCCESS, payload })
const addParticipantFailed =  (payload) => ({ type: ADD_PARTICIPANT_FAILED, payload })

export const addParticipant = (participant) => {
  return (dispatch, getState) => {
    const { currentConversation } = getState()
    dispatch(addParticipantBegin())
    return $.ajax(`/api/staff/v1/conversations/${currentConversation.id}/add_participant.json`, {
      method: 'POST',
      data: { conversation: { participant_id: participant.id }}
    }).then((response)=>{
      dispatch(addParticipantSuccess(response))
    }).fail(()=>addParticipantFailed())
  }
}